// extracted by extract-css-chunks-webpack-plugin
module.exports = {"additionalDeliveryMessageWrapper":"v2w1B","itemDesc":"sSKNW"};